import jwtDecode from 'jwt-decode';

import { AccessClaims, CompaniesProps } from '../api/login/types';
import {
  getLocalStorageClaims,
  getLocalStorageToken,
} from '../helpers/localStorage';

interface StoragedJwtProps {
  expired: boolean;
  user: {
    companies: CompaniesProps[];
    email: string;
    id: number;
    name: string;
    session_id: number;
  };
}

/**
 * The avaliahub-api token is opaque: its claims come stored from the login. A
 * token without them (control center, sessions opened before the claims) is a
 * JWT and is decoded.
 */
const readClaims = (token: string): AccessClaims | null => {
  const stored = getLocalStorageClaims();
  if (stored) return stored;

  try {
    return jwtDecode<AccessClaims>(token);
  } catch {
    return null;
  }
};

export function useStoragedJwt(): StoragedJwtProps | null {
  const jwtToken = getLocalStorageToken();

  if (!jwtToken) {
    return null;
  }

  const claims = readClaims(jwtToken);
  if (!claims) {
    return null;
  }

  const now = new Date().getTime() / 1000;
  const expired = now > claims.exp;

  const storagedData = {
    expired,
    user: claims.user,
  };

  return storagedData;
}
